import './plugins'
import './components'
// Stylesheets previously injected by Laravel via `@vite([...])` from
// resources/views/public/index.blade.php. Imported directly so the
// same bundle works for both the legacy blade-served path and the
// standalone Vite dev server (`npm run dev:public`).
import '../../sass/app.scss'
import '../../css/animate.css'
import '../css/style.css'
import { Userpilot } from 'userpilot'
import vClickOutside from 'v-click-outside'
import Vue from 'vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import Vue2Filters from 'vue2-filters'

import App from './components/App'
import Vue18nCustomPlugin from './plugins/Vue18nCustomPlugin'
import router from './router'
import store from './store'
import { startAuthWatcher } from '~/helpers/authWatcher'
// TODO(FE-424-followup): the public SPA still imports many shared
// components via `~/...` (alias points to resources/js/). Until that
// cross-SPA coupling is unwound, keep the TrustBoxWidget import on the
// shared user SPA copy so we don't duplicate code that still depends
// on `~/EventBus` and `~/plugins/themestore` anyway.
import TrustBoxWidget from '~/components/common/TrustBoxWidget'

Vue.config.productionTip = false

import VeeValidate from 'vee-validate'

// Initialize Userpilot
Userpilot.initialize('NX-482874b5')

Vue.use(VueDOMPurifyHTML)
Vue.use(Vue2Filters)
Vue.use(VeeValidate)

Vue18nCustomPlugin.install()

Vue.component('TrustBoxWidget', TrustBoxWidget)
Vue.use(vClickOutside)

startAuthWatcher({
  isLoggedIn: () => Boolean(store.getters['auth/token']),
  onForeignLogout: () => {
    store.commit('auth/LOGOUT')
    window.location.href = '/login'
  },
})

if (!window.useVue3Auth) {
  /* eslint-disable no-new */
  new Vue({
    i18n: Vue18nCustomPlugin.getInstance(),
    store,
    router,
    ...App,
    watch: {
      $route: {
        handler() {
          return Userpilot.reload()
        },
        deep: true,
        immediate: true,
      },
    },
  })
}
